module.exports = __webpack_public_path__ + "img/download (2).1f06cea6.svg";